





























































































































































































import Vue from 'vue';
import { createComponent, Ref, ref, computed } from '@vue/composition-api';

import ContentBlock from '@sbvr/common/legacy-shared/components/ContentBlock.vue';
import UIInput from '@sbvr/common/legacy-shared/components/ui/UIInput.vue';
import UISelect from '@sbvr/common/legacy-shared/components/ui/UISelect.vue';
import UIRadio from '@sbvr/common/legacy-shared/components/ui/UIRadio.vue';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';
import UISwitch from '@sbvr/common/legacy-shared/components/ui/UISwitch.vue';
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon.vue';
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav.vue';
import BottomBar from '@sbvr/common/legacy-shared/components/BottomBar.vue';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage.vue';
import useModalService from '@sbvr/web-panel/modal';

import useEditModel from '@/core/hooks/useEditModel';
import { useI18n } from '@/core/i18n';
import { useStore } from '@/core/store';
import { useRouter } from '@/core/routes';
import Device from '@/core/store/types/Device';
import DeviceStatus from '@/devices/components/DeviceStatus.vue';

function useDevice (deviceId: string) {
  const store = useStore();
  const router = useRouter();

  const defaultDevice: Device = {
    title: '',
    serialNumber: '',
    hardware: {
      name: '',
    },
    powerStatus: -1,
    maintenanceModeEnabled: false,
    launcherEnabled: true,
  };

  function deviceValidFunction (device: Ref<Device>): boolean {
    return !!device.value.title.length;
  }

  const {
    model: device,
    modelChanges: deviceChanges,
    editModel: editDevice,
    modelInStore: deviceInStore,
  } = useEditModel<Device>('Device', deviceId, defaultDevice);

  const saving = ref(false);

  const valid = computed(() => {
    return !!device.value.title;
  });

  const kioskModeValue = computed(() => {
    return device.value.kioskModeContent
      ? device.value.kioskModeContent.id
      : 'blank';
  });

  function editKioskModeContent (event): void {
    const value: string = event.target.value;

    if (value === 'blank') {
      editDevice('kioskModeContent', undefined);
    } else {
      editDevice('kioskModeContent', { id: value });
    }
  }

  async function storeDevice () {
    const payload =
      deviceId === 'new'
        ? deviceChanges.value
        : { id: deviceId, ...deviceChanges.value };

    try {
      saving.value = true;
      await store.dispatch('storeDevice', payload);
      router.push({ name: 'device-index' });
    } finally {
      saving.value = false;
    }
  }

  return {
    device,
    editDevice,
    kioskModeValue,
    editKioskModeContent,
    saving,
    valid,
    storeDevice,
    deviceInStore,
  };
}

function useDeviceGroups () {
  const store = useStore();

  const deviceGroups = computed(() => {
    return store.getters['entities/DeviceGroup/all']();
  });

  return {
    deviceGroups,
  };
}

function useContent () {
  const store = useStore();

  const content = computed(() => {
    // return store.getters['entities/Content/all']();
    return [
      {
        id: '1',
        title: 'Some Title',
      },
    ];
  });

  return {
    content,
  };
}

function useBreadcrumbs (deviceId: string, device: Ref<Device>) {
  const i18n = useI18n();

  const breadcrumbItems: any[] = [
    { name: i18n.t('Devices'), routerLink: { name: 'device-index' } },
  ];

  if (deviceId !== 'new') {
    breadcrumbItems.push({ name: device.value.title });
  } else {
    breadcrumbItems.push({ name: i18n.t('New Device') });
  }

  return {
    breadcrumbItems,
  };
}

function useDeleteModal (root: Vue) {
  const router = useRouter();
  const modalService = useModalService(root);
  const i18n = useI18n();

  async function openDeleteConfirm (): Promise<void> {
    const { confirmed } = await modalService.confirm({
      icon: 'trash',
      title: i18n.t('Are you sure you want to delete this device?'),
      message: i18n.t(
        'This will only delete the device from this list. Remember to uninstall titles or wipe the device if needed.'
      ),
      confirmText: i18n.t('Yes, delete'),
    });
    if (confirmed) {
      router.push({ name: 'device-index' });
    }
  }

  return {
    openDeleteConfirm,
  };
}

export default createComponent({
  props: {
    deviceId: {
      type: String,
      required: true,
    },
  },
  components: {
    ContentBlock,
    UIInput,
    UIButton,
    BreadcrumbNav,
    BottomBar,
    WebPanelPage,
    UISelect,
    UIRadio,
    UISwitch,
    DeviceStatus,
    UIIcon,
  },
  setup ({ deviceId }, { root }) {
    const deviceApi = useDevice(deviceId);

    return {
      ...deviceApi,
      ...useDeviceGroups(),
      ...useContent(),
      ...useBreadcrumbs(deviceId, deviceApi.device),
      ...useDeleteModal(root),
    };
  },
});
